import axios, { AxiosResponse } from 'axios'

const parseFileUrlFromXml = (xml: string): string | undefined => {
  const matches = xml.match(/<Location>(.+?)<\/Location>/)

  if (matches) {
    return matches[1]
  }

  return undefined
}

interface UploadFields {
  [key: string]: string
}

const buildFormData = (uploadFields: UploadFields, file: File): FormData => {
  const formData = new FormData()

  Object.keys(uploadFields).forEach((key) => {
    formData.append(key, uploadFields[key])
  })

  formData.append('file', file)
  return formData
}

export const uploadFileToS3 = async (
  presignedPostPath: string,
  file: File,
  localiseUrl: (path: string, options: { localeAsParam: boolean }) => string
): Promise<string | undefined> => {
  const presignedPostData: AxiosResponse<{
    url: string
    upload_fields: UploadFields
  }> = await axios.post(localiseUrl(presignedPostPath, { localeAsParam: true }))

  const { url, upload_fields } = presignedPostData.data

  const uploadedFileData: AxiosResponse<string> = await axios.post(
    localiseUrl(url, { localeAsParam: true }),
    buildFormData(upload_fields, file)
  )

  return parseFileUrlFromXml(uploadedFileData.data)
}

export const fileSizeString = (fileSizeInBytes: number): string => {
  let fileSizeInB = fileSizeInBytes
  let i = -1
  const byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB']

  do {
    fileSizeInB /= 1024
    i += 1
  } while (fileSizeInB > 1024)

  return `${Math.max(fileSizeInB, 0.1).toFixed(1)}${byteUnits[i]}`
}
